import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App';

const container = document.getElementById('root');
const application = <React.StrictMode><ErrorBoundary><App /></ErrorBoundary></React.StrictMode>;
// Production pages contain build-time rendered content; development uses an empty root.
if (container.hasChildNodes()) {
  hydrateRoot(container, application);
} else {
  createRoot(container).render(application);
}
